<template>
    <button class="lm-button"
            :class="[{loading}]"
            @click.prevent="$emit('click')"
            v-bind="$attrs"
    >
        <slot></slot>
    </button>
</template>

<script>
    export default {
        name: "LoveMapButton",
        props: {
            loading: {
                type: Boolean,
                default: false
            },
        },
    }
</script>

<style lang="scss" scoped>
    button {
        @media (max-width: 599px){
            padding: 5px 15px;
            &:first-child{
                margin-right: 1px;
            }
        }
        @media (min-width: 600px){
            &:first-child{
                margin-bottom: 1px;
            }
        }

        border: none;
        color: #fff;
        font-size: 0.8125rem !important;
        line-height: 1.4em;
        font-smoothing: antialiased;
        -webkit-font-smoothing: antialiased;
        /*order: 0;*/
        /*flex: 0 1 auto;*/
        /*align-self: auto;*/

        -webkit-appearance: button;
        /*text-transform: none;*/
        /*line-height: 1.15; !* 1 *!*/
        margin: 0; /* 2 */
        font-family: "Roboto", sans-serif;
        /*font-size: 22px!important;*/
        padding: 16px;
        font-weight: bold;
        width: 220px;
        text-transform: uppercase;
        background: #EC7A5C;

        opacity: 1;
        transition: all 0.3s;
        -webkit-transition: all 0.3s;

        cursor: pointer;
        &:hover{
            opacity: 0.6;
        }
        &:disabled{
            &.loading{
                cursor: wait;
            }
            cursor: default;
            background: #ccc;
            &:hover{
                opacity: 1;
            }
        }
    }
</style>